import { endOfWeek } from "../../utils/dateUtils";

export const resolveBlockCardIsActive = (block, activeBlockId = null) => {
  if (activeBlockId != null) {
    return String(block?.id ?? "") === String(activeBlockId);
  }

  return Boolean(block?.isActive);
};

export const resolveBlockCardTimelineState = ({
  block,
  hasDateContext,
  createdWeeks,
  totalWeeks,
  isBlockActive,
  refDate = new Date(),
}) => {
  const parsedInitialDate =
    block?.initialDate instanceof Date
      ? block.initialDate
      : new Date(block?.initialDate);
  const isFutureBlock =
    hasDateContext &&
    Number.isFinite(parsedInitialDate?.getTime?.()) &&
    parsedInitialDate > endOfWeek(refDate);
  const shouldComputeCurrentWeek =
    hasDateContext && (isBlockActive || !isFutureBlock);
  const resolvedCurrentWeek = shouldComputeCurrentWeek
    ? (block?.currentWeek?.(refDate) ?? 1)
    : 1;

  return {
    resolvedCurrentWeek,
    timelineCurrentWeek:
      hasDateContext && (isBlockActive || !isFutureBlock)
        ? resolvedCurrentWeek
        : 0,
    isBlockFullyCompleted:
      hasDateContext &&
      createdWeeks >= totalWeeks &&
      resolvedCurrentWeek >= totalWeeks,
  };
};
